import React from 'react'

interface WakeInProjectIconProps {
  size?: number
  className?: string
}

/**
 * "Wake task up in its assigned project" icon — sidebar-style project
 * tray with a check mark inside. Used as the leading icon of the
 * "Im Projekt" entry at the top of the Reactivate dropdown.
 *
 * `currentColor` so the host can theme it via CSS.
 */
export const WakeInProjectIcon: React.FC<WakeInProjectIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M14.66 15.66H1.67C1.11 15.66 0.67 15.22 0.67 14.66V1.66C0.67 1.11 1.11 0.66 1.67 0.66H14.66C15.22 0.66 15.66 1.11 15.66 1.66V14.66C15.66 15.22 15.22 15.66 14.66 15.66Z"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.66 9.66H10.66V12.66H5.67V9.66H0.67"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.67 5.66L7.67 7.66L11.66 3.66"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
